import Image1 from "../../assets/img/portfolio/LAPTOPNJPv3.jpg";
import Image2 from "../../assets/img/portfolio/KroteinBar.jpg";
import Image3 from "../../assets/img/portfolio/ToddSnyderGalSlider.jpg";
import Image4 from "../../assets/img/portfolio/KWDLogo.jpg";
import Image5 from "../../assets/img/portfolio/MySuitCustomerLogin.jpg";
import Image6 from "../../assets/img/portfolio/CharksDPOY2.jpg";
import Image7 from "../../assets/img/portfolio/Macbook-MockupAFWv3.jpg";
import Image8 from "../../assets/img/portfolio/MySuitOrderStatusv2.jpg";
import Image9 from "../../assets/img/portfolio/KreatineKreations.jpg";
import Image10 from "../../assets/img/portfolio/weekschedulemock.png";
import Image11 from "../../assets/img/portfolio/RRentals.jpg";
import Image12 from "../../assets/img/portfolio/MemoCrewLogo.jpg";
import Image13 from "../../assets/img/portfolio/NikeBusStop.jpg";
import Image14 from "../../assets/img/portfolio/break.jpg";
import Image15 from "../../assets/img/portfolio/TSSperry.jpg";
import Image16 from "../../assets/img/portfolio/MySuitBookApp.jpg";
import Image17 from "../../assets/img/portfolio/DenimShopFilterSlider.jpg";
import Image18 from "../../assets/img/portfolio/TSNHLFanaticsv2.jpg";

const PortfolioData = [
  {
    id: 1,
    type: "Web Design",
    image: Image1,
    images: [Image1],
    tag: ["web design"],
    delayAnimation: "0",
    summary:
      "Built and styled a Shopify storefront experience with a focus on clean product presentation and mobile-friendly shopping.",
    role: ["Web Design", "Frontend"],
    stack: ["Shopify", "HTML", "CSS"],
    kpis: [
      { label: "Mobile UX", value: "Improved" },
      { label: "Performance", value: "Optimized" },
      { label: "Conversion", value: "Tracked" },
    ],
    bullets: [
      "Implemented theme styling and layout improvements",
      "Optimized product imagery and merchandising presentation",
      "Ensured responsive behavior across breakpoints",
    ],
    modalDetails: [
      {
        project: "Web Design",
        client: "Freelance",
        language: "HTML, CSS, Shopify",
        preview: "www.newjerseysplug.com",
        link: "https://www.newjerseysplug.com/",
      },
    ],
  },
  {
    id: 2,
    type: "Graphic Design",
    image: Image2,
    images: [Image2],
    tag: ["graphic design"],
    delayAnimation: "100",
    summary:
      "Designed product packaging/label concept with a bold, shelf-ready layout and brand-forward typography.",

    modalDetails: [
      {
        project: "Product Design",
        client: "Freelance Client",
        program: "Adobe Illustrator",
      },
    ],
  },

  // (Image3 is imported but not used in your original file — keeping import in case you add it later)

  {
    id: 18,
    type: "Web Design",
    image: Image18,
    images: [Image18],
    tag: ["web design"],
    delayAnimation: "200",
    summary:
      "Designed and implemented a launch collection page experience for a branded collaboration with clear merchandising and navigation.",
    role: ["Web Design", "Frontend"],
    stack: ["Shopify", "HTML", "CSS"],
    kpis: [
      { label: "Launch readiness", value: "On-time" },
      { label: "Merchandising", value: "Improved" },
      { label: "CTA clarity", value: "Enhanced" },
    ],
    bullets: [
      "Styled collection layout for launch merchandising",
      "Optimized spacing/typography for scanability",
      "Ensured responsive behavior for mobile shoppers",
    ],
    modalDetails: [
      {
        project: "Fanatics NHL Launch",
        client: "Todd Snyder",
        language: " HTML, CSS, Shopify",
        preview: "Fanatics for NHL",
        link: "https://www.toddsnyder.com/collections/todd-snyder-by-fanatics-nhl",
      },
    ],
  },
  {
    id: 4,
    type: "Graphic Design",
    image: Image4,
    images: [Image4],
    tag: ["logo", "graphic design"],
    delayAnimation: "0",
    summary:
      "Created a clean, versatile logo mark intended for digital, print, and social applications.",

    modalDetails: [
      {
        project: "Logo Design",
        client: "Freelance",
        program: " Adobe Illustrator",
      },
    ],
  },
  {
    id: 16,
    type: "Web Design",
    image: Image16,
    images: [Image16],
    tag: ["web design"],
    delayAnimation: "200",
    summary:
      "Designed and built an appointment contact flow focused on reducing friction and increasing completed submissions.",
    role: ["UI/UX", "Frontend"],
    stack: ["React", "HTML", "CSS"],
    kpis: [
      { label: "Form friction", value: "Reduced" },
      { label: "Completions", value: "Improved" },
      { label: "Mobile UX", value: "Optimized" },
    ],
    bullets: [
      "Improved layout and field hierarchy for clarity",
      "Optimized the form for mobile interaction patterns",
      "Enhanced CTA visibility and spacing",
    ],
    modalDetails: [
      {
        project: "Appointment Contact Form",
        client: "My.Suit NY",
        language: " HTML, CSS, ReactJS",
        preview: "My.Suit Appointment Page",
        link: "https://www.mysuit.com/appointment",
      },
    ],
  },
  {
    id: 10,
    type: "Graphic Design",
    image: Image10,
    images: [Image10],
    tag: ["graphic design"],
    delayAnimation: "0",
    summary:
      "Designed a schedule layout concept with clear structure, hierarchy, and consistent spacing.",

    modalDetails: [
      {
        project: "Graphic Design",
        client: "Ramapo College of NJ",
        program: "Adobe Photoshop",
      },
    ],
  },
  {
    id: 5,
    type: "Web Design",
    image: Image5,
    images: [Image5],
    tag: ["web design"],
    delayAnimation: "100",
    summary:
      "Designed and implemented a customer login UI with clean form hierarchy and responsive behavior.",
    role: ["UI/UX", "Frontend"],
    stack: ["React", "HTML", "CSS"],
    kpis: [
      { label: "Form clarity", value: "Improved" },
      { label: "Accessibility", value: "Enhanced" },
      { label: "Mobile UX", value: "Optimized" },
    ],
    bullets: [
      "Improved form spacing and error-state readiness",
      "Enhanced visual hierarchy for faster scanning",
      "Ensured responsive layout on mobile devices",
    ],
    modalDetails: [
      {
        project: "Sign-in Form",
        client: "My.Suit",
        language: "HTML, CSS, ReactJS",
      },
    ],
  },
  {
    id: 15,
    type: "Web Design",
    image: Image15,
    images: [Image15],
    tag: ["web design"],
    delayAnimation: "200",
    summary:
      "Supported a branded collaboration landing experience with clean layout, strong merchandising, and responsive design.",
    role: ["Web Design", "Frontend"],
    stack: ["Shopify", "HTML", "CSS"],
    kpis: [
      { label: "Merchandising", value: "Improved" },
      { label: "Navigation", value: "Simplified" },
      { label: "Mobile UX", value: "Optimized" },
    ],
    bullets: [
      "Structured content hierarchy for campaign storytelling",
      "Styled layout for product discovery and scanability",
      "Validated responsive layout across breakpoints",
    ],
    modalDetails: [
      {
        project: "Web Design",
        client: "Todd Snyder",
        program: "HTML, CSS, Shopify",
        preview: "View Sperry by Todd Snyder",
        link: "https://www.toddsnyder.com/pages/sperry-by-todd-snyder-25",
      },
    ],
  },
  {
    id: 6,
    type: "Graphic Design",
    image: Image6,
    images: [Image6],
    tag: ["logo", "mockup", "graphic design"],
    delayAnimation: "200",
    summary:
      "Created a promotional graphic/mockup designed for social engagement with strong contrast and clean composition.",

    modalDetails: [
      {
        project: "Graphic Design",
        client: "Ramapo College of NJ",
        program: "Adobe Photoshop",
        preview: "View on Instagram",
        link: "https://www.instagram.com/p/B4hy-zwna5y/?igsh=MWdwZ2JiYWJibnJzdQ==",
      },
    ],
  },
  {
    id: 7,
    type: "Web Design",
    image: Image7,
    images: [Image7],
    tag: ["web design"],
    delayAnimation: "0",
    summary:
      "Designed and implemented a storefront mockup with a focus on product presentation, navigation clarity, and responsive behavior.",
    role: ["Web Design", "Frontend"],
    stack: ["Shopify", "HTML", "CSS"],
    kpis: [
      { label: "Product clarity", value: "Improved" },
      { label: "Mobile layout", value: "Optimized" },
      { label: "Speed", value: "Tracked" },
    ],
    bullets: [
      "Styled page layout and product grid presentation",
      "Improved navigation and merchandising hierarchy",
      "Ensured responsive behavior for key screens",
    ],
    modalDetails: [
      {
        project: "Web Design",
        client: "A Few Words",
        language: "HTML, CSS, Shopify",
        preview: "www.afewwords.shop",
        link: "https://www.afewwords.shop",
      },
    ],
  },
  {
    id: 8,
    type: "Web Design",
    image: Image8,
    images: [Image8],
    tag: ["web design"],
    delayAnimation: "100",
    summary:
      "Redesigned the order status experience to improve clarity, reduce confusion, and support faster tracking on mobile.",
    role: ["UI/UX", "Frontend"],
    stack: ["HTML", "CSS", "JavaScript"],
    kpis: [
      { label: "Support friction", value: "Reduced" },
      { label: "Clarity", value: "Improved" },
      { label: "Mobile UX", value: "Optimized" },
    ],
    bullets: [
      "Improved hierarchy and status readability",
      "Refined spacing, typography, and component consistency",
      "Enhanced layout behavior for small screens",
    ],
    modalDetails: [
      {
        project: "Order Status",
        client: "My.Suit",
        language: "HTML, CSS, Javascript",
      },
    ],
  },
  {
    id: 9,
    type: "Graphic Design",
    image: Image9,
    images: [Image9],
    tag: ["graphic design", "mockup"],
    delayAnimation: "200",
    summary:
      "Designed a supplement brand concept and mockup with bold typography, packaging realism, and consistent branding.",

    modalDetails: [
      {
        project: "Graphic Design",
        client: "Freelance",
        program: "Adobe Photoshop",
      },
    ],
  },
  {
    id: 17,
    type: "Web Design",
    image: Image17,
    images: [Image17],
    tag: ["web design"],
    delayAnimation: "200",
    summary:
      "Implemented a filterable merchandising experience to help customers browse denim options more efficiently. Giving customers a visual + a description on what they're shopping for.",
    role: ["Frontend", "Web Design"],
    stack: ["Shopify", "HTML", "CSS"],
    kpis: [
      { label: "Browse efficiency", value: "Improved" },
      { label: "Interaction", value: "Enhanced" },
      { label: "Merchandising", value: "Cleaner" },
    ],
    bullets: [
      "Supported filterable section styling and layout",
      "Improved spacing and scanability of options",
      "Validated responsive behavior for mobile browsing",
    ],
    modalDetails: [
      {
        project: "Filterable Slider",
        client: "Todd Snyder",
        language: " HTML, CSS, Shopify",
        preview: "Filterable Slider",
        link: "https://www.toddsnyder.com/collections/denim-shop",
      },
    ],
  },
  {
    id: 11,
    type: "Graphic Design",
    image: Image11,
    images: [Image11],
    tag: ["graphic design", "logo"],
    delayAnimation: "200",
    summary:
      "Designed a logo concept for a rentals brand with a simple mark optimized for digital and print usage.",

    modalDetails: [
      {
        project: "Graphic Design",
        client: "Freelance",
        program: "Adobe Illustrator",
      },
    ],
  },
  {
    id: 12,
    type: "Graphic Design",
    image: Image12,
    images: [Image12],
    tag: ["graphic design", "logo"],
    delayAnimation: "200",
    summary:
      "Created a logo and brand mark concept with clean geometry and versatile usage across platforms.",

    modalDetails: [
      {
        project: "Graphic Design",
        client: "Freelance",
        program: "Adobe Illustrator",
      },
    ],
  },
  {
    id: 13,
    type: "Graphic Design",
    image: Image13,
    images: [Image13],
    tag: ["graphic design", "logo"],
    delayAnimation: "200",
    summary:
      "Designed a promotional ad mockup with structured layout and high-contrast typography for quick scanning.",
    modalDetails: [
      {
        project: "Graphic Design",
        client: "Freelance",
        program: "Adobe InDesign",
      },
    ],
  },
  {
    id: 14,
    type: "Graphic Design",
    image: Image14,
    images: [Image14],
    tag: ["graphic design"],
    delayAnimation: "200",

    modalDetails: [
      {
        project: "Graphic Design",
        client: "Freelance Client",
        program: "Adobe Photoshop",
      },
    ],
  },
];

export default PortfolioData;
